<div class="list-header">
  <list-header class="width-15" [identifier]="'Identifier'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-35" [identifier]="'Name'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-30" [identifier]="'Grouping'"></list-header>
  <list-header class="width-20" [identifier]="'Zone'"></list-header>
</div>
<cdk-accordion *ngIf="objects | async as localities">
  <cdk-accordion-item *ngFor="let locality of localities; let index = index"
      #accordionItem="cdkAccordionItem" expanded="{{index == selection}}" role="button" tabindex="0" [attr.id]="'header-' + index">
    <div [class]="'list-item' + (selection == index ? ' selected' : '')" (click)="onToggle(accordionItem, index)">
      <span class="width-15">{{locality.identifier}}</span>
      <span class="width-35">{{locality.name}}</span>
      <span class="width-30">{{locality.grouping?.name}}</span>
      <span class="width-20">{{locality.zone?.name}}</span>
    </div>
    <div *ngIf="accordionItem.expanded" role="region" [style.display]='' [attr.id]="'body-' + index">
      <app-locality-form [object]="locality" (objectChange)="onUpdate(index, $event)" (event)="onEvent($event)"></app-locality-form>
    </div>
  </cdk-accordion-item>
</cdk-accordion>
<div class="count"><span *ngIf="total | async as total">{{count | async}} / {{total}}</span></div>
